// Aviso discreto del canal de eventos en vivo (Sala CRM<->HCE, rebanada 3). Solo aparece si el canal se cayó: con el canal abierto (o en el
// primer intento) no muestra nada. Mientras dice «Reconectando…» la pantalla sigue al día por su recarga periódica de respaldo (30 s).
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { EstadoEnVivo } from '@/lib/eventosSala';

export function IndicadorEnVivo({ estado }: { estado: EstadoEnVivo }): JSX.Element | null {
  const { t } = useTranslation();
  if (estado !== 'reconectando') return null;
  return (
    <output className="inline-flex items-center rounded-full bg-hce-paper px-2 py-0.5 font-mono text-[11px] text-hce-clay">
      {t('dashboard.reconectando')}
    </output>
  );
}
